<template>
  <div>
    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
      <p class="ck-subtitulo mb-0" style="max-width: 760px">
        Cada tablet corporativo funciona como um relógio de ponto: o colaborador digita CPF ou matrícula e senha,
        faz a verificação facial e confirma a marcação. As faixas de horário só <b>sugerem</b> o tipo de batida;
        o colaborador pode trocar e nenhuma marcação é bloqueada por horário (Portaria 671, art. 74).
      </p>
      <button class="btn btn-info" @click="editar()"><i class="bi bi-plus-lg"></i> Novo relógio</button>
    </div>

    <div v-if="carregando" class="text-center py-5"><span class="spinner-border"></span></div>
    <div v-else-if="!lista.length" class="card">
      <div class="card-body text-center py-5">
        <i class="bi bi-tablet-landscape" style="font-size: 2.4rem; color: var(--ck-primaria)"></i>
        <h5 class="mt-2">Nenhum relógio cadastrado</h5>
        <p class="ck-subtitulo">Cadastre um relógio, gere o código de ativação e abra <b>/ponto-itinerante</b> no tablet.</p>
        <button class="btn btn-info" @click="editar()">Cadastrar o primeiro relógio</button>
      </div>
    </div>

    <div class="grade-terminais">
      <div v-for="t in lista" :key="t.id" class="card terminal">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h5 class="mb-0">{{ t.nome }}</h5>
              <small class="text-muted"><i class="bi bi-building"></i> {{ t.nomefilial }}</small>
            </div>
            <span :class="['badge', estado(t).classe]">{{ estado(t).texto }}</span>
          </div>

          <div v-if="t.codigo" class="codigo-ativacao">
            <span>Código de ativação</span>
            <strong>{{ t.codigo }}</strong>
            <small>válido até {{ horaCurta(t.codigo_expira) }}</small>
          </div>

          <ul class="detalhes">
            <li><i class="bi bi-person-bounding-box"></i> Verificação facial: <b>{{ t.exigir_face ? 'obrigatória' : 'desligada' }}</b></li>
            <li><i class="bi bi-clock"></i> Último acesso: <b>{{ t.ultimo_acesso ? dataHora(t.ultimo_acesso) : 'nunca' }}</b></li>
            <li><i class="bi bi-fingerprint"></i> Marcações registradas: <b>{{ t.marcacoes }}</b></li>
          </ul>
          <div class="faixas">
            <span v-for="(f, i) in t.faixas" :key="i" class="faixa" :class="f.tipo">{{ rotTipo(f.tipo) }} {{ f.inicio }}–{{ f.fim }}</span>
          </div>
        </div>
        <div class="card-footer d-flex gap-2">
          <button class="btn btn-sm btn-info flex-fill" @click="gerarCodigo(t)"><i class="bi bi-key"></i> {{ t.ativado ? 'Reativar' : 'Gerar código' }}</button>
          <button class="btn btn-sm btn-light" @click="editar(t)" title="Editar"><i class="bi bi-pencil"></i></button>
          <button class="btn btn-sm btn-light text-danger" @click="excluir(t)" title="Excluir/desativar"><i class="bi bi-trash"></i></button>
        </div>
      </div>
    </div>

    <!-- Modal de edição -->
    <div class="modal fade" ref="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ form.id ? 'Editar relógio' : 'Novo relógio' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label>Nome do relógio</label>
                <input v-model.trim="form.nome" class="form-control" placeholder="Ex.: Tablet portaria obra Centro">
              </div>
              <div class="col-md-6">
                <label>Filial / estabelecimento</label>
                <select v-model.number="form.idfilial" class="form-select">
                  <option :value="0" disabled>Selecione</option>
                  <option v-for="f in filiais" :key="f.id" :value="f.id">{{ f.text }}</option>
                </select>
                <small class="text-muted">As marcações usam o NSR desta filial.</small>
              </div>
              <div class="col-md-4">
                <label>Situação</label>
                <select v-model.number="form.ativo" class="form-select">
                  <option :value="1">Ativo</option>
                  <option :value="0">Desativado</option>
                </select>
              </div>
              <div class="col-md-4">
                <label>Verificação facial</label>
                <select v-model.number="form.exigir_face" class="form-select">
                  <option :value="1">Obrigatória</option>
                  <option :value="0">Desligada (só senha)</option>
                </select>
              </div>
              <div class="col-md-4" v-if="form.exigir_face">
                <label>Rigor do reconhecimento: {{ rotuloRigor }}</label>
                <input type="range" min="0.4" max="0.65" step="0.01" v-model.number="form.limiar_face" class="form-range">
                <small class="text-muted">Mais rigoroso reduz fraudes, mas pode recusar fotos ruins.</small>
              </div>
            </div>

            <hr>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div>
                <strong>Horário configurado por tipo de batida</strong>
                <div class="ck-subtitulo">Dentro da faixa, o relógio já abre com o tipo selecionado.</div>
              </div>
              <button class="btn btn-sm btn-light" @click="form.faixas.push({ tipo: 'entrada', inicio: '08:00', fim: '09:00' })"><i class="bi bi-plus"></i> Faixa</button>
            </div>
            <div v-for="(f, i) in form.faixas" :key="i" class="row g-2 align-items-end mb-2">
              <div class="col-4">
                <select v-model="f.tipo" class="form-select">
                  <option value="entrada">Entrada</option>
                  <option value="pausa">Pausa (saída intervalo)</option>
                  <option value="retorno">Retorno do intervalo</option>
                  <option value="saida">Saída</option>
                </select>
              </div>
              <div class="col-3"><input type="time" v-model="f.inicio" class="form-control"></div>
              <div class="col-3"><input type="time" v-model="f.fim" class="form-control"></div>
              <div class="col-2"><button class="btn btn-light text-danger w-100" @click="form.faixas.splice(i, 1)"><i class="bi bi-trash"></i></button></div>
            </div>
            <p v-if="!form.faixas.length" class="ck-subtitulo">Sem faixas: o relógio sugere o próximo tipo pela sequência de marcações do dia.</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <button class="btn btn-info" @click="salvar" :disabled="salvando">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios'
import { Modal } from 'bootstrap'
import util from '@/util'

const TIPOS = { entrada: 'Entrada', pausa: 'Pausa', retorno: 'Retorno', saida: 'Saída' }
const FAIXAS_PADRAO = [
  { tipo: 'entrada', inicio: '05:00', fim: '10:59' },
  { tipo: 'pausa', inicio: '11:00', fim: '12:59' },
  { tipo: 'retorno', inicio: '13:00', fim: '14:59' },
  { tipo: 'saida', inicio: '15:00', fim: '23:59' },
]

export default {
  name: 'TerminaisView',
  data() {
    return {
      lista: [],
      filiais: [],
      carregando: false,
      salvando: false,
      modal: null,
      form: this.novoForm(),
    }
  },
  computed: {
    rotuloRigor() {
      const l = this.form.limiar_face
      return l <= 0.47 ? 'alto' : (l <= 0.58 ? 'equilibrado' : 'tolerante')
    },
  },
  mounted() {
    this.carregar()
    this.carregarFiliais()
  },
  methods: {
    rotTipo(t) { return TIPOS[t] || t },
    novoForm() {
      return { id: 0, nome: '', idfilial: 0, ativo: 1, exigir_face: 1, limiar_face: 0.55, faixas: JSON.parse(JSON.stringify(FAIXAS_PADRAO)) }
    },
    estado(t) {
      if (!t.ativo) return { texto: 'Desativado', classe: 'text-bg-secondary' }
      if (t.ativado) return { texto: 'Em uso', classe: 'text-bg-success' }
      return { texto: 'Aguardando ativação', classe: 'text-bg-warning' }
    },
    dataHora(v) { return util.dataBR(v) + ' ' + String(v).substring(11, 16) },
    horaCurta(v) { return String(v).substring(11, 16) },
    req(op, extra = []) {
      return util.reqaxios([{ parametro: 'op', valor: op }, { parametro: 'idempresa', valor: this.$store.state.usuario.idempresa }, ...extra],
                           'post', util.servidor + '/controller/terminal.php')
    },
    async carregar() {
      this.carregando = true
      try {
        const r = await this.req('listagem')
        this.lista = Array.isArray(r.data) ? r.data : []
      } finally {
        this.carregando = false
      }
    },
    async carregarFiliais() {
      const r = await axios.get(util.servidor + '/controller/select2sql.php', {
        params: { idempresa: this.$store.state.usuario.idempresa, token: util.token(), tabela: 'tbfiliais' },
      }).catch(() => ({ data: [] }))
      this.filiais = Array.isArray(r.data) ? r.data : []
    },
    editar(t) {
      this.form = t
        ? { id: t.id, nome: t.nome, idfilial: parseInt(t.idfilial), ativo: t.ativo, exigir_face: t.exigir_face,
            limiar_face: parseFloat(t.limiar_face), faixas: JSON.parse(JSON.stringify(t.faixas)) }
        : this.novoForm()
      if (!t && this.filiais.length === 1) this.form.idfilial = this.filiais[0].id
      if (!this.modal) this.modal = new Modal(this.$refs.modal)
      this.modal.show()
    },
    async salvar() {
      if (!this.form.nome) return util.notif('error', 'Atenção', 'Informe o nome do relógio.')
      if (!this.form.idfilial) return util.notif('error', 'Atenção', 'Selecione a filial.')
      this.salvando = true
      try {
        const r = await this.req('salvar', [{ parametro: 'registro', valor: JSON.stringify(this.form) }])
        if (typeof r.data === 'object' && r.data.sucesso === false) return util.notif('error', 'Atenção', r.data.mensagem)
        if (util.respostaOk(r.data)) {
          const novo = !this.form.id
          this.modal.hide()
          await this.carregar()
          if (novo) {
            const t = this.lista.find(x => x.id === parseInt(r.data))
            if (t) this.gerarCodigo(t)
          }
        }
      } finally {
        this.salvando = false
      }
    },
    async gerarCodigo(t) {
      if (t.ativado) {
        const ok = await Swal.fire({ title: 'Reativar relógio?', text: 'O tablet atual será desconectado e precisará do novo código.',
                                     icon: 'warning', showCancelButton: true, confirmButtonText: 'Gerar novo código', cancelButtonText: 'Cancelar' })
        if (!ok.isConfirmed) return
      }
      const r = await this.req('gerarcodigo', [{ parametro: 'id', valor: t.id }])
      if (!r.data || !r.data.sucesso) return util.notif('error', 'Atenção', (r.data && r.data.mensagem) || 'Falha ao gerar código.')
      const url = window.location.origin + '/ponto-itinerante'
      await Swal.fire({
        title: 'Código de ativação',
        html: `<div style="font-size:2.4rem;font-weight:700;letter-spacing:.25em;color:#13534a;margin:8px 0">${r.data.codigo}</div>
               <div class="text-start small">
                 1. No tablet, abra <b>${url}</b><br>
                 2. Informe o código da empresa <b>${this.$store.state.usuario.idempresa}</b> e o código acima<br>
                 3. Válido por ${r.data.validade} minutos
               </div>`,
        confirmButtonText: 'Entendi',
      })
      this.carregar()
    },
    async excluir(t) {
      const ok = await Swal.fire({ title: `Excluir "${t.nome}"?`, text: 'Relógios com marcações são apenas desativados.', icon: 'warning',
                                   showCancelButton: true, confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar' })
      if (!ok.isConfirmed) return
      const r = await this.req('excluir', [{ parametro: 'id', valor: t.id }])
      if (typeof r.data === 'string' && r.data.startsWith('I - ')) util.notif('info', r.data.substring(4), '')
      else if (typeof r.data === 'object' && r.data.sucesso === false) util.notif('error', 'Atenção', r.data.mensagem)
      this.carregar()
    },
  },
}
</script>

<style scoped lang="scss">
.grade-terminais { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 14px; }
.terminal h5 { font-size: 1.02rem; font-weight: 700; }
.codigo-ativacao {
  margin: 14px 0 4px; padding: 10px 12px; border-radius: 10px; background: #fff7e3; border: 1px dashed var(--ck-acento);
  display: flex; flex-direction: column; align-items: center;
}
.codigo-ativacao span { font-size: .72rem; text-transform: uppercase; letter-spacing: .06em; color: #8a6300; }
.codigo-ativacao strong { font-size: 1.6rem; letter-spacing: .25em; color: #5c4200; }
.codigo-ativacao small { color: #8a6300; }
.detalhes { list-style: none; padding: 0; margin: 14px 0 10px; font-size: .84rem; color: var(--ck-texto-2); }
.detalhes li { padding: 3px 0; }
.detalhes i { width: 18px; display: inline-block; }
.detalhes b { color: var(--ck-texto); font-weight: 600; }
.faixas { display: flex; flex-wrap: wrap; gap: 6px; }
.faixa { font-size: .72rem; font-weight: 600; padding: 3px 8px; border-radius: 6px; background: #eef3f1; color: var(--ck-texto-2); }
.faixa.entrada { background: #e3f4ea; color: #1e6b45; }
.faixa.pausa { background: #fff3d9; color: #8a5a00; }
.faixa.retorno { background: #e2eefa; color: #24578c; }
.faixa.saida { background: #fbe5e2; color: #96352a; }
</style>
